import { useMemo, useState } from 'react'
import {
  deleteVehicleTransfer,
  getVehiclesTransfer,
} from '../../../../services/api/https/registration/veiculos-transferencia.http'
import { errorHandler } from '../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  INITIAL_FETCH: 'Adquirindo veículos de transferência',
  DELETE_VEHICLE: 'Apagando veiculo de transferência',
  SUCCESS_DELETE: 'Veiculo apagado com sucesso',
}

const INITIAL_STATE = {
  showModal: false,
  globalFilter: '',
  selectedVehicle: null,
  vehicles: [],
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useVeiculoTransferencia() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      getVehiclesTransfer(tpId) {
        if (tpId === 0) setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
        else
          getVehiclesTransfer(tpId)
            .then(vehicles =>
              setState(prevState => ({
                ...prevState,
                vehicles: vehicles,
                loadingMessage: LOAD_MESSAGE.NONE,
              })),
            )
            .catch(err =>
              setState(prevState => ({
                ...prevState,
                errorMessage: errorHandler(err),
                loadingMessage: LOAD_MESSAGE.NONE,
              })),
            )
      },

      deleteVehicleTransfer(vehicleTransferId, tpId) {
        deleteVehicleTransfer(tpId, vehicleTransferId)
          .then(() => {
            setState(prevState => {
              prevState.vehicles = prevState.vehicles.filter(
                vehicleTransfer => vehicleTransfer.id !== vehicleTransferId,
              )
              prevState.loadingMessage = LOAD_MESSAGE.SUCCESS_DELETE
              prevState.selectedVehicle = null
              return { ...prevState }
            })
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      //Events
      onInit() {
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.INITIAL_FETCH }))
      },

      onMenuItemClicked(item, vehicleTransfer) {
        switch (item) {
          case 'Editar':
            setState(prevState => ({
              ...prevState,
              showModal: true,
              selectedVehicle: vehicleTransfer,
            }))
            break

          case 'Apagar':
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.DELETE_VEHICLE,
              selectedVehicle: vehicleTransfer,
            }))
            break

          default:
            break
        }
      },

      onInputFilter(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },

      onBtnNovo(selectedTp) {
        if (selectedTp !== 0) setState(prevState => ({ ...prevState, showModal: true }))
        else setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
      },

      onModalSave(vehicleTransfer) {
        setState(prevState => {
          const index = prevState.vehicles.findIndex(vehicle => vehicle.id === vehicleTransfer.id)
          if (index !== -1) prevState.vehicles[index] = vehicleTransfer
          else prevState.vehicles.push(vehicleTransfer)
          prevState.showModal = false
          prevState.selectedVehicle = null
          return { ...prevState }
        })
      },

      onModalClose() {
        setState(prevState => ({ ...prevState, showModal: false, selectedVehicle: null }))
      },
    }
  }, [])

  return { state, localDispatch }
}
